module.exports = __webpack_public_path__ + "img/gpkfive_packs.topps.1808c90.png";